import "../../new.scss";
import { useState, useEffect, useContext } from "react";
import { RolesFormContext } from '../../../context/roles/RolesContext';
import { useParams, useNavigate } from 'react-router-dom';
import { Tabs, Tab, Box } from '@mui/material';
import { AccionesRolesState } from '../../../context/accionesroles/AccionesRolesState';
import AccionesRolesGrid from './AccionesRoles/AccionesRolesGrid';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import Inputs from "./configForm/inputs";
import { handleInputChange } from "./helpersForm/formHandlers";

export const Form = ({ title }) => {
  const [form, setForm] = useState({});
  const { postRolData, report, patchRolData, rolesAccionesData } = useContext(RolesFormContext);
  // Estado para controlar las pestañas
  const [tabIndex, setTabIndex] = useState(0);
  // ID de edicion 
  const { id } = useParams();
  // Navigate to datagrid
  const navigate = useNavigate();
  // Manejo de errors
  const [errors, setErrors] = useState({})
  // Estado de Carga
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Dialogs de advertencia y error
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  //Maejo de Acciones 
  const [rolesAccionesDataForm, setRolesAccionesDataForm] = useState();

  const nameData = "roles";
  const saveData = postRolData;
  const updateData = patchRolData;

  useEffect(() => {
    if (report && Object.keys(report).length > 0) {
      setForm(report);
    }
  }, [report]);


  useEffect(() => {

    if (rolesAccionesData && Object.keys(rolesAccionesData).length > 0) {
      setRolesAccionesDataForm(rolesAccionesData);

    }
  }, [rolesAccionesData]);


  useEffect(() => {
    if (report && Object.keys(report).length > 0) {
      setForm(report);
    }
  }, [report]);

  const handleChange = (e) => {
    handleInputChange(e, setForm, Inputs, setErrors, form);
  };

  const validateForm = () => {
    let formErrors = {};
    Inputs.forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) formErrors[name] = error;
      }
    });
    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };

  // Mostrar diálogos
  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };
  const closeErrorDialog = () => setIsErrorDialogOpen(false);

  // Enviar datos
  const handleSendData = () => {
    if (!validateForm()) {
      openErrorDialog("Por favor, corrige los errores antes de continuar.");
      return;
    }
    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();

    try {
      if (id) {
        await updateData(id, form);
      } else {
        await saveData(form);
      }
      navigate(`/${nameData}`);
    } catch (error) {
      console.error(error);
      openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(`/${nameData}`);
  };


  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">

            <Tabs value={tabIndex} onChange={handleTabChange}>
              <Tab label="General" />
              <Tab label="Permisos" />
            </Tabs>
            {/* TAB GENERAL*/}
            <Box sx={{ padding: 2 }}>
              {tabIndex === 0 && (
                <>
                  <form>
                    {Inputs.map((input) => (
                      <FormField
                        key={input.name} // Asegúrate de incluir una clave única para cada elemento en el mapeo
                        input={input}
                        value={form[input.name]}
                        handleInputChange={handleChange}
                        error={errors[input.name]}
                      />
                    ))}
                  </form>
                </>
              )}

              {/* TAB PRECIOS */}
              {tabIndex === 1 && (
                <>
                  {id ? (
                    <>
                      <AccionesRolesState>
                        <AccionesRolesGrid
                          idRol={form.id}
                          nombreRol={form.nombre}
                        />
                      </AccionesRolesState>
                    </>
                  ) : (
                    <Box sx={{ padding: 2 }}>
                      <p>Debe guardar el registro antes de acceder a esta pestaña.</p>
                    </Box>
                  )}
                </>
              )}
            </Box>


            {/* Botones */}
            <form> </form>
              <FormButtons
                isSubmitting={isSubmitting}
                handleSave={handleSendData}
                handleCancel={handleCancel}
                saveText="Guardar"
                cancelText="Cancelar"
              />
            
            {/* Diálogos */}
            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar este registro?"
            />
            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title=""
            />
          </div>
        </div>
      </div>
    </div >
  );
};

export default Form;
